import React from 'react';
import { PullRefreshState } from '../../hooks';

type PullRefreshIndicatorProps = {
  refreshState: PullRefreshState;
  visible: boolean;
};

export const PullRefreshIndicator: React.FC<PullRefreshIndicatorProps> = ({
  refreshState,
  visible,
}) => {
  return (
    <div
      className={`pull-refresh-indicator ${visible ? 'visible' : ''} ${refreshState}`}
    >
      <div className="pull-refresh-indicator-pill font-medium">
        <div className="pull-refresh-row">
          <div className="spinner" />
        </div>
      </div>
    </div>
  );
};
